const Types: ITypes = {
	javascript: 'javascript',
	css: 'css',
	video: 'video',
};
export default Types;
export interface ITypes {
	javascript: 'javascript';
	css: 'css';
	video: 'video';
}
